const lclImportChargesData1 = {
    initialLength: 14,
    preList: [{
            id: 1,
            chargeDescription: 'Pick-up Charges',
            currency: 'INR',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            disabled: ['perCBM','perTon','maximum', 'minimum']
        },
        {
            id: 2,
            chargeDescription: 'Export Customs Clearance',
            currency: 'INR',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            disabled: ['perCBM','perTon','maximum', 'minimum']
        },
        {
            id: 3,
            chargeDescription: 'Origin Charges',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: 'INR'
        },
        {
            id: 4,
            chargeDescription: 'Origin Inland Haulage',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: 'INR'
        },
        {
            id: 5,
            chargeDescription: 'Ocean Freight',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: 'USD',
            disabled: ['perShipment']
        },
        {
            id: 6,
            chargeDescription: 'Hazardous Surcharge',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: 'USD'
        },
        {
            id: 7,
            chargeDescription: 'Non-Stackable Surcharge',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: 'USD'
        },
        {
            id: 8,
            chargeDescription: 'Destination Inland Haulage',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: ''
        },
        {
            id: 9,
            chargeDescription: 'Destination Charges',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: ''
        },
        {
            id: 10,
            chargeDescription: 'Destination CFS Charges',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: ''
        },
        {
            id: 11,
            chargeDescription: 'Import Customs Clearance',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            disabled: ['perCBM','perTon','maximum', 'minimum']
        },
        {
            id: 12,
            chargeDescription: 'Door Delivery Charges',
            currency: '',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            disabled: ['perCBM','perTon','maximum', 'minimum']
        },{
            id: 13,
            chargeDescription: 'Terminal Handling Fees',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
             disabled: ['perCBM','perTon','maximum', 'minimum']     
        },{
            id: 14,
            chargeDescription: 'BL Fees',
           perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
             disabled: ['perCBM','perTon','maximum', 'minimum']
        }
    ]
}
export default lclImportChargesData1